export const GUEST_CHECKOUT_EXPERIMENT_NAME = 'tourist_checkout_test_m_pc' as const;
export const GUEST_CHECKOUT_ASSIGNMENT_STORAGE_KEY = 'zl-tourist_checkout_test_m_pc' as const;

export type GuestCheckoutExperimentValue = 1 | 2;

export type GuestCheckoutRegion = 'north_america' | 'other_locale';
export type GuestCheckoutSiteName = 'de' | 'us' | 'ca' | 'fr' | 'uk';

export type GuestCheckoutExposureEntry =
  | 'cart_view'
  | 'header_cart_hover'
  | 'checkout_click'
  | 'direct_payment'
  | 'fallback';

export interface GuestCheckoutAssignment {
  experimentName: typeof GUEST_CHECKOUT_EXPERIMENT_NAME;
  experimentValue: GuestCheckoutExperimentValue;
  storageKey: typeof GUEST_CHECKOUT_ASSIGNMENT_STORAGE_KEY;
  region: GuestCheckoutRegion;
  exposureEntry: GuestCheckoutExposureEntry;
  assignmentReady: boolean;
  assignedAt: number;
}

export interface GuestCheckoutStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
}

export interface GuestCheckoutAssignmentOptions {
  /** Optional dependency injection for tests and non-standard browser shells. */
  storage?: GuestCheckoutStorage | null;
  /** Uses the configured site when omitted. */
  siteName?: GuestCheckoutSiteName;
}

export interface GuestCheckoutAddress {
  id?: string;
  is_pobox?: number;
  country_id?: string | number;
  country?: string;
  province_id?: string | number;
  province?: string;
  city?: string;
  street?: string;
  apartment?: string;
  postcode?: string;
  cpf?: string;
  tel_code?: string;
  tel_country?: string;
  telephone?: string;
  firstname?: string;
  lastname?: string;
  address?: string;
  default?: number;
}

export interface GuestCheckoutCache {
  contactEmail?: string;
  shipping?: GuestCheckoutAddress;
  shippingAddressId?: string;
}

export interface GuestCheckoutCachePatch {
  contactEmail?: string | null;
  shipping?: GuestCheckoutAddress | null;
  shippingAddressId?: string | number | null;
}

export interface GuestCheckoutCacheOptions {
  /** Optional dependency injection for tests and non-standard browser shells. */
  storage?: GuestCheckoutStorage | null;
  /** Visitor id used to isolate the cache from other browser visitors. */
  visitorId?: string;
}
